import { defineStore } from 'pinia'

const NOINDEX = -1;
export const deviceStore = defineStore('deviceStore', {
  state: () => {
    return {
      clients : [],
      viewPorts : [],
      terminationPoints : [],
      addHeaderRightIcons : [],
      addHeaderLeftIcons : [],
      rootMenu : [],
      meetingMenu : {
        Live : [],
        Recent : [],
        Folders : []
      },
      meetingIndex : [],
      LandingPage : true,
      panelStack : [],
      activeClient : {},
      activeViewportId: null,
      behaviours : {},
      behaviourConfig : {},
      graphConfig : {},
      currentState : 'Begun',
      role : null,
      action : null,
      result : null,
      qualifier : null,
      liveContacts : [],
      meetingContacts : [],
      allContacts : [],
      smartView: false,
      smartPanels: []
    }
  },
  getters : {
    isLanding(state) {
      return state.LandingPage;
    },
    isSmartView(state) {
      return state.smartView;
    },
    isMediaPlayer(state) {
      return (clientId) => state.viewPorts.filter((storeView) => storeView.ClientID == clientId).find((viewports) => state.terminationPoints.find((terminations) => terminations.viewportID == viewports.viewportID && terminations.Template == 'oxygen-mediaplayer'));
    },
    getMeetingIndex(state) {
      return (meetingId) => state.meetingIndex.findIndex((localMeetingId) => localMeetingId == meetingId);
    },
    getbehaviourConfig(state) {
      return (clientId) => state.behaviourConfig[clientId];
    },
    getgraphConfig(state) {
      return (clientId) => state.graphConfig[clientId];
    },
    getActiveClient(state) {
      return state.activeClient;
    },
    getActiveViewportId(state) {
      return state.activeViewportId;
    },
    getViewportsByClient(state) {
      return (clientId) => state.viewPorts.filter((localViewports) => localViewports.ClientID == clientId);
    },
    getRootmenuByLocalIndex(state) {
      return (localIndex) => state.rootMenu.find((rootMenu) => rootMenu.LocalIndex == localIndex);
    },
    getRootMenuByPath(state) {
      return (path) => state.rootMenu.find((rootMenu) => rootMenu.Path == path);
    },
    getRootMenuByClient(state) {
      return (clientid) => state.rootMenu.find((rootMenu) => rootMenu.ClientRowID == clientid);
    },  
    getRootMenuByViewPort(state) {
      return (viewportid) => state.rootMenu.find((rootMenu) => rootMenu.ViewPortID == viewportid);
    },
    getViewPortStyle(state){
      return (viewPortId) => {
          let viewPort = state.viewPorts.find((storeView) => storeView.viewportID == viewPortId);
          if(viewPort) {
              let borderColor = (viewPort.ClientID === this.activeClient.Client) ? '#0072c5' : 'lightgray';
              let zIndex = ( viewPortId === this.activeViewportId ) ? 99999 : 99998;
              let style =  (viewPort.LocalState != 'Hide') ?
                  `z-index:${zIndex};border:2px solid ${borderColor};border-radius:0.3em;padding:4px;box-shadow:0 0 0 2px white,0 0 0 4px ${borderColor};` : `z-index:99999;display:none`;
              return style;
          } else {
            let style = "z-index:99999;border:2px solid lightgray;border-radius:0.3em;padding:4px;box-shadow:0 0 0 2px white,0 0 0 4px lightgrey;";
            return style;
          }
      };
    },
    getHeaderStyle(state) {
      return (viewPortId) => {
          let viewPort = state.viewPorts.find((storeView) => storeView.viewportID == viewPortId);
          if(viewPort) {
            if(viewPort.LocalState == "Blink") {
              let style =  'animation: blinker 1s linear infinite;';
              return style;
            } else {
              let style = '';
              return style;
            }
          }
      };
    },
    getViewPortPosition(state) {
      return (viewPortId) => {
          let viewPort = state.viewPorts.find((storeView) => storeView.viewportID == viewPortId);
          if(viewPort) {
            return { x: viewPort.TopLeftX, y: viewPort.TopRightY };
          } else {
            return { x: 0, y: 0 };
          }
      };
    },
    getLastActivePanel(state) {
      return this.panelStack.slice().pop();
    }
  },
  actions: {
    setLanding(status) {
      this.LandingPage = status;
    },
    setSmartView(status) {
      this.smartView = status;
    },
    setbehaviourConfig(client, behaviours) {
       this.behaviourConfig[client.Client] = behaviours;
    },
    setGraphConfig(clientId, behaviours) {
      this.graphConfig[clientId] = behaviours;
    },
    addClient(client) {
      let index = this.clients.findIndex((clientObj) => clientObj.clientID == client.clientID);
			if(index != NOINDEX) {
				this.clients[index] = client;
			} else {
        this.clients.push(client);
      }
    },
    addViewPort(viewport) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewport.viewportID);
			if(index != NOINDEX) {
				this.viewPorts[index] = viewport;
			} else {
        this.viewPorts.push(viewport);
      }
    },
    delViewPort(viewport) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewport.viewportID);
			if(index != NOINDEX) {
        this.viewPorts.splice(index, 1);
			}
    },
    addsmartPanels(page) {
      this.smartPanels.push(page);
    },
    addMessageBox(viewportID, MessageBox) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
      if(index != NOINDEX) {
        this.viewPorts[index].MessageBox = MessageBox;
      }
    },
    setCurrentView(viewportID, currentView) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
      if(index != NOINDEX) {
        this.viewPorts[index].CurrentView = currentView;
      }
    },
    addRightMemu(viewportID, rightMemu) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
			if(index != NOINDEX) {
        if(this.viewPorts[index].rightMenu) {
          this.viewPorts[index].rightMenu.push(rightMemu);
        } else {
          this.viewPorts[index].rightMenu = [rightMemu];
        }
			}
    },
    addEmailonMessageBox(viewportID, email) {
      //console.log("addEmailonMessageBox dev store",viewportID,email);
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
      //console.log("addEmailonMessageBox dev store index",viewportID,index);
      if(index != NOINDEX) {
        if(this.viewPorts[index].MessageBox) {
          //console.log("addEmailonMessageBox MessageBox exist",viewportID,email);
          this.viewPorts[index].MessageBox.addEmail(email);
        } else {
          //console.log("addEmailonMessageBox MessageBox does not exist");
        }
			}
    },
    addPhoneonMessageBox(viewportID, phone) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
			if(index != NOINDEX) {
        if(this.viewPorts[index].MessageBox) {
          this.viewPorts[index].MessageBox.addPhone(phone);
        }
			}
    },
    addLeftRibbonIcon(viewportID,params) {
      //console.log("addLeftRibbonIcon two"+viewportID,params);

      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
			if(index != NOINDEX) {
        if(this.viewPorts[index].headerRibbon) {
          //console.log("addLeftRibbonIcon 3"+viewportID,params);
          this.viewPorts[index].headerRibbon.addLeftRibbonIcon(params.iconId,params,params.callback,params.toolTip,params.show,params.position);
        }
			}
    },
    addRightRibbonIcon(viewportID,params) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
      if(index != NOINDEX) {
        if(this.viewPorts[index].headerRibbon) {
          this.viewPorts[index].headerRibbon.addRightRibbonIcon(params.iconId,params,params.callback,params.toolTip,params.show,params.position);
        }
      }
    },
    updateIconInfo(viewportID,params) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
      if(index != NOINDEX) {
        if(this.viewPorts[index].headerRibbon) {
          this.viewPorts[index].headerRibbon.updateIconInfo(params.iconId,params);
        }
      }
    },
    hideRibbonIcon(viewportID,params) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
      if(index != NOINDEX) {
        if(this.viewPorts[index].headerRibbon) {
          this.viewPorts[index].headerRibbon.hideRibbonIcon(params.iconId,params);
        }
      }
    },
    showRibbonIcon(viewportID,params) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
      if(index != NOINDEX) {
        if(this.viewPorts[index].headerRibbon) {
          this.viewPorts[index].headerRibbon.showRibbonIcon(params.iconId,params);
        }
      }
    },
    changeRibbonIconColor(viewportID,params) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
      if(index != NOINDEX) {
        if(this.viewPorts[index].headerRibbon) {
          this.viewPorts[index].headerRibbon.changeRibbonIconColor(params.iconId,params);
        }
      }
    },
    addTerminationPoint(termination) {
      let index = this.terminationPoints.findIndex((storeTermination) => storeTermination.terminationID == termination.terminationID);
			if(index != NOINDEX) {
				this.terminationPoints[index] = termination;
			} else {
        this.terminationPoints.push(termination);
      }
    },
    delTerminationPoint(termination) {
      let index = this.terminationPoints.findIndex((storeTermination) => storeTermination.terminationID == termination.terminationID);
			if(index != NOINDEX) {
        this.terminationPoints.splice(index, 1);
			}
    },
    addHeaderRightIcon(IconObj) {
      let index = this.addHeaderRightIcons.findIndex((RightIcon) => RightIcon.RightIconID == IconObj.RightIconID);
			if(index != NOINDEX) {
				this.addHeaderRightIcons[index] = IconObj;
			} else {
        this.addHeaderRightIcons.push(IconObj);
      }
    },
    addHeaderLeftIcon(IconObj) {
      let index = this.addHeaderLeftIcons.findIndex((LeftIcon) => LeftIcon.LeftIconID == IconObj.LeftIconID);
			if(index != NOINDEX) {
				this.addHeaderLeftIcons[index] = IconObj;
			} else {
        this.addHeaderLeftIcons.push(IconObj);
      }
    },
    addRootMenu(node) {
      let index = this.rootMenu.findIndex((storeNode) => storeNode.Path == node.Path);
			if(index != NOINDEX) {
				this.rootMenu[index] = node;
			} else {
        this.rootMenu.push(node);
      }
    },
    delRootMenu(node) {
      let index = this.rootMenu.findIndex((storeNode) => storeNode.Path == node.Path);
			if(index != NOINDEX) {
        this.rootMenu.splice(index, 1);
			}
    },
    updateRootMenu(node) {
      //console.log('updateRootMenu', 'node:', node);
      let index = this.rootMenu.findIndex((storeNode) => storeNode.Path == node.Path);
			if(index != NOINDEX) {
        if(node.ClientRowID) {
            this.rootMenu[index].ClientRowID = node.ClientRowID;
        }
        if(node.ViewPortID) {
            this.rootMenu[index].ViewPortID = node.ViewPortID;
        }
        if(node.TerminationID) {
            this.rootMenu[index].TerminationID = node.TerminationID;
        }
        if(node.LeftDN) {
          this.rootMenu[index].LeftDN = node.LeftDN;
        }
        if(node.RightDN) {
          this.rootMenu[index].RightDN = node.RightDN;
        }


        if(node.Reset) {
          this.rootMenu[index].ViewPortID = null;
          this.rootMenu[index].TerminationID = null;
        }
        if(node.ResetTermination) {
          this.rootMenu[index].TerminationID = null;
        }
			}
      //console.log('updateRootMenu', 'viewportClasses:', node.viewportClasses);
      if(node.viewportClasses) {

        this.rootMenu[index].viewportClasses = node.viewportClasses;
        //console.log('adding viewport classes: ', this.rootMenu[index].viewportClasses)
      }
    },
    addMeetingMenuLive(menu) {
      let index = this.meetingMenu.Live.findIndex((storeMenu) => storeMenu.Path == menu.Path);
      if(index != NOINDEX) {
        this.meetingMenu.Live[index] = menu;
      } else {
        this.meetingMenu.Live.push(menu);
      }
    },
    delMeetingMenuLive(menu) {
      let index = this.meetingMenu.Live.findIndex((storeMenu) => storeMenu.Path == menu.Path);
      if(index != NOINDEX) {
        this.meetingMenu.Live.splice(index, 1);
      }
    },
    addMeetingMenuRecent(menu) {
      let index = this.meetingMenu.Recent.findIndex((storeMenu) => storeMenu.Path == menu.Path);
      if(index != NOINDEX) {
        this.meetingMenu.Recent[index] = menu;
      } else {
        this.meetingMenu.Recent.push(menu);
      }
    },
    delMeetingMenuRecent(menu) {
      let index = this.meetingMenu.Recent.findIndex((storeMenu) => storeMenu.Path == menu.Path);
      if(index != NOINDEX) {
        this.meetingMenu.Recent.splice(index, 1);
      }
    },
    addMeetingMenuFolder(menu) {
      let index = this.meetingMenu.Folders.findIndex((storeMenu) => storeMenu.Path == menu.Path);
      if(index != NOINDEX) {
        this.meetingMenu.Folders[index] = menu;
      } else {
        this.meetingMenu.Folders.push(menu);
      }
    },
    delMeetingMenuFolder(menu) {
      let index = this.meetingMenu.Folders.findIndex((storeMenu) => storeMenu.Path == menu.Path);
      if(index != NOINDEX) {
        this.meetingMenu.Folders.splice(index, 1);
      }
    },
    addMeetingIndex(meetingId) {
      let index = this.meetingIndex.findIndex((localMeetingId) => localMeetingId == meetingId);
			if(index == NOINDEX) {
				this.meetingIndex.push(meetingId);
			}
    },
    setActiveClient(clientObj) {
      //console.log('setActiveClient', 'clientObj:', clientObj);
      this.activeClient = clientObj;
    },
    setActiveViewportId(viewportId) {
      this.activeViewportId = viewportId;
    },
    setCurrentState(thread, subject, state) {
      let componentEdge = thread+subject;
      //console.log("set current state two"+componentEdge+"==="+state);
      if(this.behaviours[componentEdge] != undefined) {
        //console.log("set current state two"+this.behaviours[componentEdge].State);
        this.behaviours[componentEdge].State = state;
        //console.log("set current state three"+this.behaviours[componentEdge].State);
      }
    },
    initBehaviour(client) {
      let componentEdge = client.ClientLeft + client.ClientRight;

      if(this.behaviours[componentEdge] == undefined) {
        this.behaviours[componentEdge] = {Role : '', Action : '', State : '', Result : '', Qualifier : '', Rules : [], FormData : {}, EventHandlers : {}};
      }

    },
    addBehaviours(thread, subject, behaviours) {
      let componentEdge = thread + subject;

      behaviours.forEach((behaviour) => {
        let index = this.behaviours[componentEdge].Rules.findIndex((storeBehaviour) => storeBehaviour.Action == behaviour.Action && storeBehaviour.State == behaviour.State && storeBehaviour.Result == behaviour.Result);
        if(index != NOINDEX) {
          this.behaviours[componentEdge].Rules[index] = behaviour;
        } else {
          this.behaviours[componentEdge].Rules.push(behaviour);
        }
      });
    },
    delBehaviours(behaviours) {
      behaviours.forEach((behaviour) => {
        let index = this.behaviours.findIndex((storeBehaviour) => storeBehaviour.Action == behaviour.Action && storeBehaviour.State == behaviour.State && storeBehaviour.Result == behaviour.Result);
        if(index != NOINDEX) {
          this.behaviours.splice(index, 1);
        }
      });
    },
    regBehaviourEventHandlers(thread,subject, EventHandlers) {
      let componentEdge = thread + subject;
      //console.log("register event handler got store",componentEdge,"==",EventHandlers,"===",typeof(EventHandlers.Result))
      if(this.behaviours[componentEdge] && this.behaviours[componentEdge].EventHandlers) {
        if(typeof(EventHandlers.Role) === 'function') {
          this.behaviours[componentEdge].EventHandlers.Role = EventHandlers.Role;
        }
        if(typeof(EventHandlers.Action) === 'function') {
          this.behaviours[componentEdge].EventHandlers.Action = EventHandlers.Action;
        }
        if(typeof(EventHandlers.Result) === 'function') {
          this.behaviours[componentEdge].EventHandlers.Result = EventHandlers.Result;
        }
      }
    },
    ShowPanel(viewportID) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
			if(index != NOINDEX) {
        this.viewPorts[index].LocalState = 'Show';
			}
    },
    HidePanel(viewportID) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
			if(index != NOINDEX) {
        this.viewPorts[index].LocalState = 'Hide';
			}
    },
    BlinkPanel(viewportID) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
			if(index != NOINDEX) {
        this.viewPorts[index].LocalState = 'Blink';
			}
    },
    ClosePanel(viewportID) {
      let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == viewportID);
      if(index != NOINDEX) {
        this.viewPorts[index].LocalState = 'Close';
      }
    },
    MovePanel(params) {
      if(params.viewportID && params.TopLeftX && params.TopRightY) {
        let index = this.viewPorts.findIndex((storeView) => storeView.viewportID == params.viewportID);
        if(index != NOINDEX) {
          this.viewPorts[index].TopLeftX = params.TopLeftX;
          this.viewPorts[index].TopRightY = params.TopRightY;
        }
      }
    },
    AddToPanelStack(viewportID) {
      let index = this.panelStack.findIndex((stackedViewport) => stackedViewport == viewportID);
      if(index != NOINDEX) {
        this.panelStack.splice(index, 1);
        this.panelStack.push(viewportID);
      } else {
        this.panelStack.push(viewportID);
      }
    },
    DelFromPanelStack(viewportID) {
      let index = this.panelStack.findIndex((stackedViewport) => stackedViewport == viewportID);
      if(index != NOINDEX) {
        this.panelStack.splice(index, 1);
      }
    }
  }
})
